import { render } from "./PaymentAdminsManagement.vue?vue&type=template&id=5d508b65&scoped=true"
import script from "./PaymentAdminsManagement.vue?vue&type=script&lang=js"
export * from "./PaymentAdminsManagement.vue?vue&type=script&lang=js"

import "./PaymentAdminsManagement.vue?vue&type=style&index=0&id=5d508b65&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d508b65"]])

export default __exports__